var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"tw-flex tw-flex-col shipment-search-item tw-rounded flex-fixed",attrs:{"to":{
    name: _vm.routeName,
    params: {
      uuid: _vm.shipment.uuid
    }
  }}},[_c('shipment-item-header',{attrs:{"shipment":_vm.shipment,"has-expiration":false,"has-infos":false}}),_c('shipment-item-content',{attrs:{"shipment":_vm.shipment,"has-options":false,"has-price":false,"has-tracking":false,"has-cancellation-dates":false,"has-rating":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }